import { Button, InputAdornment, TextField } from '@material-ui/core'
import { rgba } from 'polished'
import { MdChat, MdPhoneIphone } from 'react-icons/md'
import { Box } from 'reoil'
import { palette } from '../theme'
import { useFormik } from 'formik'
import { useEffect, useState } from 'react'
import useLogin from '../hooks/api/useLogin'
import { useSetLoginState } from '../store/loginState'
import { toast } from 'react-toastify'
import { BASE_URL_PROD } from '../constants/url'
import goto from '../utils/goto'

interface LoginProps {
  onSuccess?: (token: string)=>void
}

const isProd = process.env.NODE_ENV === 'production'

const Login: React.FC<LoginProps> = ({onSuccess}) => {
  const [picCaptcha, setPicCaptcha] = useState<string>(`${isProd?BASE_URL_PROD:''}/cool/captcha.php`)
  const [countDown, setCountDown] = useState<number>(0) // 验证码倒计时时间
  const setLoginState = useSetLoginState()

  useEffect(()=>{
    if(countDown>=1) {
      setTimeout(() => {
        setCountDown(prev=>prev-1)
      }, 1000)
    }
  }, [countDown])

  // 验证码倒计时
  const resetCountDown = ()=>{
    setCountDown(60)
  }

  // 刷新captcha
  const refreshPicCaptcha = ()=>{
    setPicCaptcha(`${isProd?BASE_URL_PROD:''}/cool/captcha.jpg?${Math.round(Math.random()*10000)}`)
  }

  // 登录方法
  const { getCaptcha, login } = useLogin()

  // 点击获取验证码
  const handleClickGetCaptcha = async ()=>{
    resetCountDown() //重新倒计时

    const res = await getCaptcha({
      yzm: formik.values.picCaptcha,
      mobile: formik.values.phone
    })

    if(!res) {
      formik.setErrors({captcha: '请稍后重新尝试获取'})
      refreshPicCaptcha()
    }
  }

  const formik = useFormik({
    initialValues: {
      phone: '',
      picCaptcha: '',
      captcha: ''
    },
    validate: values => {
      let errors = Object()
      if (values.phone.toString().length !== 11) errors.phone = '请输入正确的手机号'
      if (!values.picCaptcha) errors.picCaptcha = '请输入图形验证码'
      if (!values.captcha) errors.captcha = '请输入验证码'

      return errors
    },
    validateOnChange: false,
    onSubmit: async values => {
      // console.log(JSON.stringify(values, null, 2))
      const res = await login({code: values.captcha, yzm: values.picCaptcha, mobile: values.phone})
      if(res) {
        console.log( '登录成功', res )
        setLoginState({isLogin: true, avatar: res.headerimg})
        onSuccess && onSuccess(res.token)
        goto('/user')
        toast('登录成功', {type: 'success'})
      }else {
        refreshPicCaptcha()
      }
    }
  })

  return (
    <Box
      className='Login'
      bg='white'
      p={3}
      borderRadius={1}
      width='70vmin'
      maxWidth={400}
      stretch
      onClick={ev => ev.stopPropagation()}
    >
      <Box center my={3}>
        <h3>请先登录</h3>
      </Box>
      <Box className='form' stretch>
        <TextField
          label='手机号'
          type='number'
          name='phone'
          error={!!formik.errors.phone}
          helperText={formik.errors.phone}
          required
          onChange={formik.handleChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <MdPhoneIphone />
              </InputAdornment>
            )
          }}
        />

        <Box my={2}></Box>

        <Box row center>
          <TextField
            label='图形验证码'
            name='picCaptcha'
            required
            error={!!formik.errors.picCaptcha}
            helperText={formik.errors.picCaptcha}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <MdChat />
                </InputAdornment>
              )
            }}
            style={{ flex: 1 }}
            onChange={formik.handleChange}
          />
          <Box onClick={refreshPicCaptcha} pointer width={100} p={1} ml={1} border='divider' borderRadius={50} fit='contain'><img src={picCaptcha} alt=""/></Box>
        </Box>

        <Box my={2}></Box>

        <Box row center>
          <TextField
            label='验证码'
            name='captcha'
            type='number'
            required
            error={!!formik.errors.captcha}
            helperText={formik.errors.captcha}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <MdChat />
                </InputAdornment>
              )
            }}
            style={{ flex: 1 }}
            onChange={formik.handleChange}
          />
          <Button
            variant='outlined'
            color='primary'
            style={{ whiteSpace: 'nowrap', marginLeft: 12, borderRadius: 50 }}
            onClick={handleClickGetCaptcha}
            disabled={countDown>0}>
            {countDown>0 ? `${countDown}s后再获取` : '获取验证码'}
          </Button>
        </Box>

        <Box my={2}></Box>

        <Box className='btn' stretch py={3} borderBox>
          <Box
            bg='primary'
            py={3}
            borderRadius={50}
            color='white'
            boxShadow={`0 8px 10px -5px ${rgba(palette.blue, 0.4)}`}
            center
            onClick={formik.submitForm}
          >
            登录
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Login
